import { defineComponent as _defineComponent } from 'vue'
import { TxData } from "@/api/tx.broadcast.base.api";
import i18n from "@/plugins/i18n";
import { useConfigurationStore } from "@/store/configuration.store";
import { useToast } from "vue-toastification";
import Icon from "@/components/features/IconComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TxToast',
  props: {
    tx: { type: Object, required: false },
    errorTitleMessage: { type: String, required: false },
    errorMessage: { type: String, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

function isSuccess(): boolean {
  return props.tx !== undefined && props.tx.code === 0;
}

function copyTxHash(){
  if (props.tx?.transactionHash) {
    navigator.clipboard.writeText(props.tx?.transactionHash);
    useToast().success(i18n.global.t("COPY.TX_HASH"));
  }
}


const __returned__ = { props, isSuccess, copyTxHash, get i18n() { return i18n }, get useConfigurationStore() { return useConfigurationStore }, Icon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})